import React from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { change, reset } from 'redux-form';
import SearchPage from './SearchPage';
import { searchForm } from 'constants/FormConstants';
import { formValueSelector, getFormValues } from 'redux-form';

const SearchPageWithNavigate = (props) => {
  const navigate = useNavigate();
  return <SearchPage {...props} navigate={navigate} />;
};

const mapStateToProps = (state) => {
  const {
    referenceData: {
      clientSummaries,
      treatmentTypes,
      destinations,
      jobStandards,
      areas,
      jobLocations,
    },
  } = state;

  const formValues = formValueSelector(searchForm);

  return {
    clientSummaries,
    treatmentTypes,
    destinations,
    jobStandards,
    areas,
    jobLocations,
    initialValues: {
      includeCompletedJobs: true,
    },
    treatmentDateFrom: formValues(state, 'treatmentDateFrom'),
    treatmentDateTo: formValues(state, 'treatmentDateTo'),
    formValues: getFormValues(searchForm)(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        change,
        reset,
      },
      dispatch,
    ),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(SearchPageWithNavigate);
